
export class User {
    userGuid: string;
    emailAddress: string;
    firstName: string;
    lastName: string;
    loginName: string;
}


